<template>
  <body>
      <div class="overflow-y-auto ">
        <div class="cont">
          <div class="logo-placeholder mt-5">
            <img :src="'/imgs/Aruvaa_default.png'" alt="logo" class="" width="" />
            <h3 class="mt-3 text-gray-700 font-semibold mx-5">Enjoy Connecting with WhatsApp Web!</h3>
            <p class="text-md font-medium text-gray-700 mx-5"> Enable notifications to receive updates and messages even when the tab is closed.</p>
          </div>
        
        </div>
      </div>
  </body>
</template>
   
<script type='text/javascript'>
import AppLayout from "@/Layouts/AppLayout.vue";
import NavBar from "@/Layouts/NavBar.vue";

export default {
  props: {
    selectedId: String,
    selectedType: String,
  },
  components: {
    AppLayout,
    NavBar,
  },
  data() {
    return {

    };
  },

  methods: {

  },
  mounted() {
    // document.addEventListener('DOMContentLoaded', function () {
    //   window.setTimeout(document.querySelector('img').classList.add('animated'),1000);
    // })
  },
};
</script >
   
<style>


.remove-top-margin {
  margin-top: 0;
}

.cont {
  position: absolute;
  top: 40%;
  left: 52%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.logo-placeholder {
  /* padding: 5px; */
  text-align: center;
}
img{
  display: inline;
}
</style>
  